import { Typography } from "@mui/material";
import { aguserStore, loginStore } from "../state/CommonState";

export function WelcomeCard(){
    return   <span style={{ height: "64px", display: "flex", justifyContent: "space-between",flexDirection:"column" }}>
    <p className="text-black font-semibold text-2xl">Hello,<span className="text-blue-dark capitalize">{" " + aguserStore.aguserRec.firstName}</span></p>
    <p className="font-medium">This is what we’ve got for you today</p>
</span>
}